import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@iconify/icons-mdi/delete";
import PencilIcon from "@iconify/icons-mdi/pencil";
import { InlineIcon } from "@iconify/react";

interface MyDocumentsDocumentEditorButtonsProps {
  setShowConfirmDialog: (value: boolean) => void;
  onEditDocument: (row: any) => void;
  row: any;
}

export const MyDocumentsDocumentEditorButtons: React.FC<
  MyDocumentsDocumentEditorButtonsProps
> = ({ setShowConfirmDialog, onEditDocument, row }) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center">
      <InlineIcon
        id="deleteIcon"
        icon={DeleteIcon}
        width="24px"
        style={{
          color: theme.palette.owGray.main,
          cursor: "pointer",
        }}
        onClick={() => setShowConfirmDialog(true)}
      />
      <Box width="8px" />
      <InlineIcon
        id="pencilIcon"
        icon={PencilIcon}
        width="24px"
        style={{
          color: theme.palette.owGray.main,
          cursor: "pointer",
        }}
        onClick={() => onEditDocument(row)}
      />
    </Box>
  );
};

export default MyDocumentsDocumentEditorButtons;
